import { useMedia } from 'react-use';

const useDevice = () => {
  const isMobileSm = useMedia('(max-width : 640px)');
  const isMobile = useMedia('(max-width: 768px)');
  const isTablet = useMedia('(min-width: 769px) and (max-width: 1024px)');
  const isDesktop = useMedia('(min-width: 1025px)');

  return {
    isMobileSm,
    isMobile,
    isTablet,
    isDesktop,
  };
};

export default useDevice;
